<mat-dialog-content class="rounded-0 avs-device-info-dialog">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Geräteinformationen</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseClicked()">
    </div>
    <span class="text-secondary">{{ data.title }}</span>

    <div class="mt-3">
        <div *ngFor="let row of rows" class="d-flex align-items-center border-bottom py-1">
            <span class="text-secondary avs-device-info-label">{{ row.label }}</span>
            <span class="flex-grow-1 font-monospace avs-device-info-value">{{ row.value }}</span>
            <img *ngIf="row.key === 'serialNumber'" class="avs-icon-copy ms-2 p-1" src="assets/icons/copy.svg"
                alt="copy-serial-number-icon" matTooltip="Seriennummer kopieren" (click)="onCopySerialNumberClicked()">
        </div>
    </div>

    <div class="d-flex justify-content-between mt-4 border-top pt-3">
        <button class="btn btn-sm btn-outline-primary rounded-0" (click)="onCopyAllClicked()">
            <img class="me-1" width="16" src="assets/icons/copy.svg" alt="copy-all-icon">Alles kopieren
        </button>
        <button class="btn btn-sm btn-outline-danger rounded-0 ms-auto" (click)="onCloseClicked()">Schließen</button>
    </div>
</mat-dialog-content>
